import React from 'react'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { SearchProfiles } from '@core/Areas/BetLoop/Components/SearchProfiles'
import { MainContainer } from '@core/Components/Containers'
import { useAppSeo } from '@core/Utils/hooks/useAppSeo'

export const SearchProfilesPage = () => {
  useAppSeo({
    title: 'Search | TABtouch',
    description: 'Explore search content and betting information with TABtouch.',
  })

  return (
    <MainContainer background='surface300'>
      <PageHeader title='Find Profiles' />
      <SearchProfiles />
    </MainContainer>
  )
}
